import React from "react";

function StaticsCardTeamLead({ marktertatistics, courseName }) {
  return (
    <div className="statics_card">
      <h5>{courseName}</h5>
      <p className="number">{marktertatistics}</p>
      {/* <CircularChart statics={statics.districts} label="احياء" /> */}
    </div>
  );
}

export default StaticsCardTeamLead;
